import { useCallback, useState } from "react";

const defaultState = {
  name: "",
  description: "",
  files: null,
  errors: {
    files: null,
    name: null,
  },
};

export default function useCloneAudioState() {
  const [cloneAudioState, setCloneAudioState] = useState(defaultState);

  const updateName = useCallback(function (name) {
    setCloneAudioState((prevState) => {
      return {
        ...prevState,
        name,
        errors: {
          ...prevState.errors,
          name: !name ? "Name is required" : null,
        },
      };
    });
  }, []);

  const updateDescription = useCallback(function (description) {
    setCloneAudioState((prevState) => {
      return {
        ...prevState,
        description,
      };
    });
  }, []);

  const updateFiles = useCallback(function (file) {
    setCloneAudioState((prevState) => {
      return {
        ...prevState,
        files: file,
        errors: {
          ...prevState.errors,
          files: !file ? "Please upload an audio file" : null,
        },
      };
    });
  }, []);

  const validateCloneAudioState = useCallback(function (state) {
    if (!state.files || !state.name) {
      setCloneAudioState((prevState) => {
        return {
          ...prevState,
          errors: {
            name: !prevState.name ? "Name is required" : null,
            files: !prevState.files ? "Please upload an audio file" : null,
          },
        };
      });

      return { isValid: false };
    }

    return { isValid: true };
  }, []);

  return {
    cloneAudioState,
    updateName,
    updateDescription,
    updateFiles,
    validateCloneAudioState,
  };
}
